import { Shield, Mail } from 'lucide-react';

const LoginFooter = ({ t }) => (
  <div className="text-center mt-6 space-y-3">
    <div className="flex justify-center items-center gap-5 flex-wrap">
      <a href="/privacy"
        className="inline-flex items-center gap-1.5 text-xs transition-colors"
        style={{ color: "var(--lm-ink-3)" }}
        onMouseEnter={e => (e.currentTarget.style.color = "var(--lm-ink-2)")}
        onMouseLeave={e => (e.currentTarget.style.color = "var(--lm-ink-3)")}
      >
        <Shield className="w-3.5 h-3.5" />
        {t.privacyPolicy}
      </a>
      <a href="mailto:support@mawered.com"
        className="inline-flex items-center gap-1.5 text-xs transition-colors"
        style={{ color: "var(--lm-ink-3)" }}
        onMouseEnter={e => (e.currentTarget.style.color = "var(--lm-ink-2)")}
        onMouseLeave={e => (e.currentTarget.style.color = "var(--lm-ink-3)")}
      >
        <Mail className="w-3.5 h-3.5" />
        {t.technicalSupport}
      </a>
    </div>
    <p className="text-xs" style={{ color: "var(--lm-border-2)" }}>{t.copyright}</p>
  </div>
);

export default LoginFooter;
